import { css } from '@emotion/css';

export const summaryHeading = css`
  object-fit: contain;
  font-family: Nunito;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  color: #00acf0;
  padding-top: 10px;
`;

export const txtSummaryLeft = css`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #727272;
  padding-left: 10px;
  padding-bottom: 6px;
  padding-top: 6px;
`;
export const txtSummaryRight = css`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: right;
  color: #5e5e5e;
  padding-right: 10px;
  padding-bottom: 6px;
  padding-top: 6px;
`;
export const txtSummary = css`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #727272;
  padding-top: 25px;
`;

export const textLeft = css`
  font-size: 12px;
  line-height: 1.33;
  color: #727272;
  padding: 6px;
  width: 50%;
`;

export const textRight = css`
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: #727272;
  padding: 6px;
  width: 50%;
`;

export const grabFooter = css`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  line-height: 15px;
  letter-spacing: 0.14px;
  font-size: 0.8rem;
  padding-bottom: 4px;
  background-color: #fff;
`;
